var collapsible_list_pair_default = {
  "container": "U9IlB",
  "title": "D7JJm",
  "viewerContainer": "NhfY6",
  "titleContainer": "HkanK",
  "expandIcon": "UIRX1",
  "dndIcon": "WtiNT",
  "RTL": "ytxes",
  "LTR": "yyrDV",
  "itemContainer": "evQpx",
  "itemContainerViewer": "P6jcM",
  "mouseDown": "wgZfl",
  "innerEditor": "p60Vz",
  "item": "sPwBM",
  "floatingAddPluginMenuWrapper": "LfrQz",
  "childrenHidden": "eKhAy"
};
export {
  collapsible_list_pair_default as default
};
//# sourceMappingURL=collapsible-list-pair-scss.js.map
